import React, { useEffect, useState } from 'react';
import { Plus, Trash2, Edit3, X, Save } from 'lucide-react';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const EMPTY = { title: '', subtitle: '', description: '', ctaLabel: 'Order Now', ctaUrl: '/menu', image: '', active: true };

export default function AdminDeals() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const { toast } = useToast();
  const load = () => api.get('/admin/deals').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const on = (k) => (e) => setForm({ ...form, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing === 'new') await api.post('/admin/deals', form);
      else await api.put(`/admin/deals/${editing}`, form);
      toast({ title: 'Saved', description: form.title });
      setEditing(null); setForm(EMPTY); load();
    } catch (err) {
      toast({ title: 'Error', description: err?.response?.data?.detail || 'Save failed' });
    }
  };

  const del = async (i) => { if (!window.confirm(`Delete "${i.title}"?`)) return; await api.delete(`/admin/deals/${i.id}`); load(); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading font-bold text-3xl text-[#0F1C2E]">Deals</h1>
        <button onClick={() => { setEditing('new'); setForm(EMPTY); }} className="btn-wrappus text-sm"><Plus size={16} /> Add Deal</button>
      </div>

      {editing && (
        <form onSubmit={save} className="bg-white rounded-2xl p-6 shadow-sm mb-6 space-y-4">
          <div className="flex items-center justify-between"><h2 className="font-heading font-bold text-lg">{editing === 'new' ? 'New Deal' : 'Edit Deal'}</h2><button type="button" onClick={() => setEditing(null)} className="p-2 hover:bg-gray-100 rounded"><X size={18} /></button></div>
          <div className="grid md:grid-cols-2 gap-4">
            <F label="Subtitle *"><input required value={form.subtitle} onChange={on('subtitle')} className="in" placeholder="e.g. Any Day, Any Time!" /></F>
            <F label="Title *"><input required value={form.title} onChange={on('title')} className="in" /></F>
            <F label="CTA Label"><input value={form.ctaLabel} onChange={on('ctaLabel')} className="in" /></F>
            <F label="CTA URL"><input value={form.ctaUrl} onChange={on('ctaUrl')} className="in" /></F>
            <F label="Image URL" full><input value={form.image} onChange={on('image')} className="in" placeholder="https://..." /></F>
            <F label="Description *" full><textarea rows={2} required value={form.description} onChange={on('description')} className="in resize-none" /></F>
            <F label="Active" full><label className="flex items-center gap-2 mt-1"><input type="checkbox" checked={form.active} onChange={on('active')} className="accent-[#ED2E2E]" /> Show on homepage</label></F>
          </div>
          <button type="submit" className="btn-wrappus text-sm"><Save size={16} /> Save</button>
          <style>{`.in{width:100%;border-radius:0.75rem;border:1px solid #E5E7EB;background:white;padding:0.65rem 0.9rem;font-size:0.9rem;} .in:focus{outline:none;border-color:#ED2E2E;box-shadow:0 0 0 3px rgba(237,46,46,0.15);} `}</style>
        </form>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {items.map((i) => (
          <div key={i.id} className="bg-white rounded-2xl shadow-sm p-6 flex gap-4">
            {i.image && <img src={i.image} alt={i.title} className="w-24 h-24 rounded-xl object-cover shrink-0" />}
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-3">
                <div><div className="text-xs text-[#ED2E2E] font-bold uppercase">{i.subtitle}</div><h3 className="font-heading font-bold text-[#0F1C2E]">{i.title}</h3></div>
                <span className={`text-xs px-2 py-1 rounded-full font-semibold ${i.active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-500'}`}>{i.active ? 'Active' : 'Hidden'}</span>
              </div>
              <p className="text-sm text-gray-600 mt-1 line-clamp-2">{i.description}</p>
              <div className="flex gap-2 mt-3">
                <button onClick={() => { setEditing(i.id); setForm(i); }} className="p-2 hover:bg-gray-100 rounded text-gray-500 hover:text-[#ED2E2E]"><Edit3 size={16} /></button>
                <button onClick={() => del(i)} className="p-2 hover:bg-red-50 rounded text-gray-500 hover:text-red-600"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function F({ label, children, full }) {
  return <div className={full ? 'md:col-span-2' : ''}><label className="text-xs font-semibold text-gray-600 uppercase block mb-1">{label}</label>{children}</div>;
}
